import axios from "axios";

export const resetPassword = (email) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/usermanagement/resetpassword/" +
        encodeURIComponent(email)
    )
    .then((res) => res);
};

export const getUsers = (isSa, isAdmin, isLightAdmin, isClientAdmin) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/usermanagement/" +
        encodeURIComponent(isSa) +
        "/" +
        encodeURIComponent(isAdmin) +
        "/" +
        encodeURIComponent(isLightAdmin) +
        "/" +
        encodeURIComponent(isClientAdmin)
    )
    .then((res) => {
      var users = [];
      // Get Careers Users that the logged in user is able to edit roles for. This list
      // will be all Careers Users that have a Careers Role that is equal or lesser than
      // the currently logged in user's Careers Role
      res.data.editableCareersUsers.forEach((careersUser) => {
        users.push(careersUser);
      });
      // Get CRM users that the logged in user is able to edit roles for. Mark these
      // as editCrmOnly. We DO NOT want the user to be able to edit Careers Roles for
      // these users as they will be users that have a Careers Role greater than the
      // currently signed in user.
      res.data.editableCRMUsers.forEach((crmUser) => {
        crmUser.editCrmOnly = true;
        users.push(crmUser);
      });
      return users;
    });
};

export const getAllRoles = () => {
  return axios
    .get(import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/usermanagement/allRoles")
    .then((res) => res.data);
};

export const editPermissions = (userId, roleId, rightsFlag, crmRole) => {
  var roleIdQueryParam = "";
  // roleId will be undefined any time a user is being assigned a CRM Role for a
  // Base Client that does not have Careers enabled or anytime a user is assigned to
  // CRM for a Client but NOT Careers
  if (roleId !== undefined) {
    roleIdQueryParam = "&roleId=" + encodeURIComponent(roleId);
  }
  return axios
    .put(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/usermanagement/editPermissions?userId=" +
        encodeURIComponent(userId) +
        roleIdQueryParam +
        "&rightsFlag=" +
        encodeURIComponent(rightsFlag) +
        "&crmRole=" +
        encodeURIComponent(crmRole)
    )
    .then((res) => res.data);
};

export const editUser = (userId, data) => {
  return axios
    .put(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/usermanagement/edit/" + encodeURIComponent(userId),
      data
    )
    .then((res) => res.data);
};

export const deleteUser = (userId) => {
  return axios
    .delete(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/usermanagement/delete/" +
        encodeURIComponent(userId)
    )
    .then((res) => res);
};

export const activate = (userId, activate) => {
  return axios
    .put(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/usermanagement/activate/" +
        encodeURIComponent(userId) +
        "/" +
        encodeURIComponent(activate)
    )
    .then((res) => res);
};

export const createUser = (data) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/usermanagement/createUser",
      data
    )
    .then((res) => res);
};
